import type { BillingBlockedPayload } from '@/types/billing'

type BlockedHandler = (payload: BillingBlockedPayload, messages: string[]) => void

const handlers = new Set<BlockedHandler>()

/** Subscribe to global billing-block events (fired from the apiClient interceptor). */
export const onBillingBlocked = (handler: BlockedHandler): (() => void) => {
  handlers.add(handler)
  return () => {
    handlers.delete(handler)
  }
}

export const emitBillingBlocked = (payload: BillingBlockedPayload, messages: string[]): void => {
  handlers.forEach((handler) => handler(payload, messages))
}
